import { createApp } from 'vue'
import App from './App.vue'

import './assets/main.css'
import CategoryVue from './components/Category.vue';
import ChooseCategoryVue from './components/ChooseCategory.vue';
import EntryListVue from './components/EntryList.vue';
import EntryScreenVue from './components/EntryScreen.vue';

const app = createApp(App)

//for trying to make modal a singleton
app.config.globalProperties.modal = {};
app.config.globalProperties.msg = 'hello world'


app.mount('#app')
//trying to allow vue to be ok with hot reloading- it loads app before other components and complains when they aren't loaded yet...
//Category, ChooseCategory, EntryScreen, EntryList 
// app.component('Category', CategoryVue);
// app.component('ChooseCategory', ChooseCategoryVue);
// app.component('EntryScreen', EntryScreenVue);
// app.component('EntryList', EntryListVue);
